import LocalMenuSelect from "~/apps/directorysearch/components/LocalMenuSelect.js";

function LocalResults({
    departments,
    selectedDept,
    setMenuSelectItem,
    titleFilterItems,
    selectedTitleFilter,
    deptFilterItems,
    selectedDeptFilter,
    hitsPerPage,
    updateHitsPerPage,
    searchResults,
    searchState,
}){
    const setDeptTitle = (deptTitle) => {
        setMenuSelectItem(deptTitle, false);
    };

    const setDeptFilter = (deptFilter) => {
        setMenuSelectItem(deptFilter, true, 'deptFilter');
    };

    const setTitleFilter = (titleFilter) => {
        setMenuSelectItem(titleFilter, true, 'titleFilter');
    };

    const resetHitsPerPage = () => {
        updateHitsPerPage();
    };

    const hasSearchTerm = searchState.query && searchState.query.trim().length > 0;
    const hasResults = hasSearchTerm && searchResults && searchResults.nbHits && searchResults.nbHits !== 0;
    const nbHits = searchResults && searchResults.nbHits;

    const departmentUpdateLink = <>
        &nbsp;For Directory of Departments <a href="https://www.sfsu.edu/atoz/">visit A to Z listing</a>
    </>;

    return hasSearchTerm ?
        (hasResults ?
            <>
                <h2>Search Results</h2>
                <p className="result-summary">
                    Results 1 - {Math.min(hitsPerPage, nbHits)} of about {nbHits} for <q>{searchState.query}</q>.
                    <br className="hide-sm-up"/>
                    {departmentUpdateLink}
                </p>
                <div className="flex margin-bottom-lg vertical-center">
                    <span className="filter-label">Filter</span>
                    <LocalMenuSelect
                        items={titleFilterItems}
                        selectedItem={selectedTitleFilter}
                        setSelectedItem={setTitleFilter}
                        resetHitsPerPage={resetHitsPerPage}
                        attribute="positions.csu_working_title"
                        seeAllTitle="Title"
                        limit={30}
                        filter
                    />
                    <LocalMenuSelect
                        items={deptFilterItems}
                        selectedItem={selectedDeptFilter}
                        setSelectedItem={setDeptFilter}
                        resetHitsPerPage={resetHitsPerPage}
                        attribute="positions.dept_title"
                        seeAllTitle="Departments"
                        limit={500}
                        filter
                    />
                </div>
            </> :
            <p className="result-summary">
                There are no results for this query.
                <br className="hide-sm-up"/>
                {departmentUpdateLink}
            </p>
        ) :
        <div className="flex margin-bottom-lg vertical-center flex-50-50-md-up">
            <div className="left-align-fill">
                <LocalMenuSelect
                    items={departments}
                    selectedItem={selectedDept}
                    setSelectedItem={setDeptTitle}
                    resetHitsPerPage={resetHitsPerPage}
                    attribute="positions.dept_title"
                    seeAllTitle="Search by Department"
                    limit={500}
                />
            </div>
            <p className="result-summary-with-department-filter">{departmentUpdateLink}</p>
        </div>
}
export default LocalResults;
